<div class="auth">
  <main class="auth-main">
    <a href="https://citalinkpro.com" class="auth-logo">
      <img src="./assets/images/logo/new-logo.svg" class="dark:hidden" alt="CitaLink Pro" width="158" height="32" />
      <img src="./assets/images/logo/new-logo-dark.svg" class="hidden dark:block" alt="CitaLink Pro" width="158"
        height="32" />
    </a>

    <div class="auth-content">
      <router-outlet></router-outlet>
    </div>

    <button type="button" class="auth-theme" (click)="toggleDarkMode()">
      @if (darkModeService.darkModeEnabled()) {
      <svg width="16" height="16" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <circle cx="10" cy="10" r="3.6" stroke="currentColor" stroke-width="1.5" />
        <path d="M10 2v1.8M10 16.2V18M2 10h1.8M16.2 10H18M4.3 4.3l1.3 1.3M14.4 14.4l1.3 1.3M4.3 15.7l1.3-1.3M14.4 5.6l1.3-1.3"
          stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
      </svg>
      Usar modo claro
      } @else {
      <svg width="16" height="16" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <path d="M16.9 12.2A7 7 0 0 1 7.8 3.1a7 7 0 1 0 9.1 9.1Z" stroke="currentColor" stroke-width="1.5"
          stroke-linejoin="round" />
      </svg>
      Usar modo oscuro
      }
    </button>
  </main>

  <aside class="auth-aside">
    <div class="agenda" aria-hidden="true">
      <div class="agenda-head">
        <span class="agenda-weekday">{{ today.weekday }}</span>
        <span class="agenda-date">{{ today.day }}</span>
        <span class="agenda-month">{{ today.month }}</span>
      </div>

      <ol class="agenda-slots">
        @for (slot of slots; track slot.time; let i = $index) {
        <li class="slot" [class.slot--new]="slot.isNew" [class.slot--free]="!slot.service" [style.--i]="i"
          [style.--tone]="slot.tone">
          <time class="slot-time">{{ slot.time }}</time>
          @if (slot.service) {
          <div class="slot-body">
            <span class="slot-service">{{ slot.service }}</span>
            <span class="slot-detail">{{ slot.detail }}</span>
          </div>
          @if (slot.isNew) {
          <span class="slot-badge">Nueva</span>
          }
          } @else {
          <span class="slot-service">Espacio libre</span>
          }
        </li>
        }
      </ol>
    </div>

    <div class="aside-copy">
      <h2>Tus clientes reservan solos. Tú te dedicas a atender.</h2>
      <p>Prueba gratis por 7 días. Agenda, clientes e inventario en un solo lugar.</p>
    </div>
  </aside>
</div>
